<div class="rd-widget table-widget">
  <table class="widgetLeaseComparablesSummaryClass widget-large cellspacing-0 cellpadding-0" *ngIf="widgetData" aria-hidden="true">
    <thead>
      <dynamic-growth-row [row]="1" [widget]="this">
        <tr class="widget-ruller-flex">
          <th scope="col" colspan="31" class="widget-grid-column investor-surveys-widget-red">
            <widget-value class="land-registry-tenure-widget-header" [align]="'left'" [color]="'white'" [bold]="true">{{widgetData.widgetHeader}}</widget-value>
          </th>
        </tr>
      </dynamic-growth-row>
    </thead>
    <tbody>
      <dynamic-growth-row [row]="2" [widget]="this">
        <tr class="top-row">
          <td colspan="1" class="darkGreyTableHeader align-left"><label class="header-label"></label></td><!--AreaName-->
          <td colspan="6" class="darkGreyTableHeader align-left"><label class="header-label">{{'investorSurveys.labelPropertyType' | rdTranslate}}</label></td>
          <td colspan="6" class="darkGreyTableHeader align-left"><label class="header-label">{{'investorSurveys.labelSource' | rdTranslate}}</label></td>
          <td colspan="6" class="darkGreyTableHeader align-left"><label class="header-label">{{'investorSurveys.labelPeriod' | rdTranslate}}</label></td>
          <td colspan="6" class="darkGreyTableHeader align-left"><label class="header-label"></label></td><!--RangeOrAverage-->
          <td colspan="6" class="darkGreyTableHeader align-left"><label class="header-label">{{'investorSurveys.labelCapRate' | rdTranslate}}</label></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="3" [widget]="this">
        <tr class="top-row">
          <widget-value class="land-registry-tenure-widget-header" [align]="'left'">{{widgetData.widgetSubheader1}}</widget-value>
        </tr>
      </dynamic-growth-row>
      {{widgetData.rowIndexes | json}}
    <ng-container *ngFor="let area of widgetData.areas; let i = index;">
      
      <dynamic-growth-row [row]="area.rowIndex" [widget]="this">
        <tr class="areaNameRow">
          <td colspan="31" class="align-left">{{ area.areaName }}</td>
        </tr>
      </dynamic-growth-row>
      <ng-container *ngFor="let row of area.rows; let j = index">
        <dynamic-growth-row [row]="row.rowIndex" [widget]="this">
          <tr>
            <td colspan="1" class="align-left">&nbsp;</td>
            <td *ngIf="row.propertyTypeRows > 0" [attr.rowspan]="row.propertyTypeRows" colspan="6" class="align-left"><label>{{row.propertyType}}</label></td>
            <td *ngIf="row.sourceRows > 0" [attr.rowspan]="row.sourceRows" colspan="6" class="align-left"><label>{{row.source}}</label></td>
            <td colspan="6" class="align-left"><label>{{row.period}}</label></td>
            <td colspan="6" class="align-left"><label>{{row.rangeOrAverage}}</label></td>
            <td colspan="6" class="align-left"><label>{{row.capRateFormatted}}</label></td>
          </tr>
        </dynamic-growth-row>
      </ng-container>
    </ng-container>
    </tbody>
  </table>
</div>
